import * as yup from "yup";

export type TcmPlanNote = {
  id: string;
  author: string;
  createdAt: string;
  body: string;
};

export type TcmTelehealthEncounter = {
  id: string;
  scheduleDate: string;
  meetingLink: string;
  patientName: string;
  provider: string;
  scheduledBy: string;
  scheduledOn: string;
  notif1Sent: boolean;
  notif2Sent: boolean;
  notif3Sent: boolean;
  notif4Sent: boolean;
  notif5Sent: boolean;
  transcript: string;
  recordingLink: string;
  status: "scheduled" | "cancelled";
};

export const TCM_DISCHARGED_FROM_OPTIONS = [
  { label: "Acute Hospital", value: "acute_hospital" },
  { label: "Inpatient Psych", value: "inpatient_psych" },
  { label: "SNF Part A", value: "snf_part_a" },
  { label: "Observation", value: "observation" },
  { label: "Partial Hospitalization", value: "partial_hospitalization" },
];

export const TCM_DISCHARGED_TO_OPTIONS = [
  { label: "Home", value: "home" },
  { label: "Domiciliary", value: "domiciliary" },
  { label: "Rest Home", value: "rest_home" },
  { label: "ALF", value: "alf" },
];

export const TCM_COMPLEXITY_OPTIONS = [
  { label: "Moderate (CPT 99495 - face-to-face within 14 days)", value: "moderate" },
  { label: "High (CPT 99496 - face-to-face within 7 days)", value: "high" },
];

export const TCM_PLAN_STATUS_OPTIONS = [
  { label: "In Progress", value: "in_progress" },
  { label: "Non Compliant", value: "non_compliant" },
  { label: "Complete", value: "complete" },
];

export const TCM_TELEHEALTH_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Scheduled", value: "scheduled" },
  { label: "Completed", value: "completed" },
];

export const TCM_ICD_OPTIONS = [
  { label: "I50.9 - Heart Failure, Unspecified", value: "I50.9" },
  { label: "E11.9 - Type 2 Diabetes Mellitus", value: "E11.9" },
  { label: "I10 - Essential (primary) Hypertension", value: "I10" },
  { label: "J44.9 - Chronic Obstructive Pulmonary Disease", value: "J44.9" },
  { label: "N18.9 - Chronic Kidney Disease, Unspecified", value: "N18.9" },
];

export const tcmPlanInitialValues = {
  dischargeDate: "",
  dischargedFrom: "",
  dischargedTo: "",
  // dischargeFacility: "",
  complexity: "",
  // icdCodes: [] as string[],
  planStatus: "in_progress",
  telehealthStatus: "pending",
  twoDayReachout: "no",
};

export const tcmPlanSchema = yup.object({
  dischargeDate: yup.string().required("Discharge date is required"),
  dischargedFrom: yup.string().trim().required("Discharged from is required"),
  dischargedTo: yup.string().trim().required("Discharged to is required"),
  // dischargeFacility: yup.string().trim().required("Discharge facility is required"),
  complexity: yup.string().oneOf(["moderate", "high"]).required("Complexity is required"),
  // icdCodes: yup.array().of(yup.string()).min(1, "Select at least one ICD code"),
  planStatus: yup
    .string()
    .oneOf(["in_progress", "non_compliant", "complete"])
    .required("TCM status is required"),
  telehealthStatus: yup
    .string()
    .oneOf(["pending", "scheduled", "completed"])
    .required("Telehealth status is required"),
  twoDayReachout: yup.string().oneOf(["yes", "no"]),
});

export const DUMMY_TCM_NOTES: TcmPlanNote[] = [
  {
    id: "note-1",
    author: "Sandra Santos",
    createdAt: "10/03/2026 02:15 PM",
    body: "Completed the 2-day post-discharge call. Discharge medications reconciled. Patient denies dizziness or acute shortness of breath.",
  },
];

export const DUMMY_TCM_ENCOUNTERS: TcmTelehealthEncounter[] = [
  {
    id: "enc-1",
    scheduleDate: "11/02/2026 10:30 AM",
    meetingLink: "https://whereby.com/anthrocare",
    patientName: "Joshua Levell",
    provider: "Dr. Sarah Jenkins",
    scheduledBy: "Sandra Santos",
    scheduledOn: "10/03/2026 09:15 AM",
    notif1Sent: true,
    notif2Sent: true,
    notif3Sent: false,
    notif4Sent: false,
    notif5Sent: false,
    transcript: "Visit transcript will appear after the call.",
    recordingLink: "",
    status: "scheduled",
  },
];

export function isUpcomingEncounter(encounter: TcmTelehealthEncounter) {
  if (encounter.status === "cancelled") return false;
  const parsed = new Date(encounter.scheduleDate);
  if (Number.isNaN(parsed.getTime())) return encounter.status === "scheduled";
  return parsed.getTime() > Date.now();
}
